import React, { Component } from "react";
import PropTypes from "prop-types";
import MessagesList from "./messages";
import MessageInput from "./input";
import { Flex } from "antd";

class Chat extends Component {
  render() {
    return (
      <Flex style={{ flex: 1 }} vertical justifyContent="flex-end">
        <MessagesList
          messages={this.props.messages}
          getEarlierMessages={this.props.getEarlierMessages}
          premiums={this.props.premiums}
          isTyping={this.props.isTyping}
        />
        <MessageInput
          onSubmit={this.props.onSubmit}
          onBlur={this.props.onEndTyping}
          onFocus={this.props.onStartTyping}
          tarots={this.props.tarots}
          consultantId={this.props.consultantId}
          initialMessage={this.props.initialMessage}
          saveTempMessage={this.props.saveTempMessage}
        />
      </Flex>
    );
  }
}

Chat.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSubmit: PropTypes.func,
  onStartTyping: PropTypes.func,
  onEndTyping: PropTypes.func,
  reloadMessages: PropTypes.func,
  getEarlierMessages: PropTypes.func,
  consultantId: PropTypes.number,
};

Chat.defaultProps = {
  onSubmit: null,
  onStartTyping: () => null,
  onEndTyping: () => null,
  reloadMessages: null,
  getEarlierMessages: null,
};

export default Chat;
